import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';

import { EntekhabinoLogo, KeepaLogoWhite } from 'assets';
import useFindLocation from 'hooks/useFindLocation';

import ImageKit from '../Image';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '100vh',
		background: theme.palette.primary[800],
	},
	entekhabino: {
		background: theme.palette.background.light,
	},
	animation: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		animation: 'ripple 5s ease',
	},
	'@keyframes ripple': {
		'0%': {
			transform: 'scale(.4)',
			opacity: 1,
		},
		'25%': {
			transform: 'scale(.8)',
			opacity: 0.5,
		},
		'50%': {
			transform: 'scale(1.2)',
			opacity: 0.5,
		},
		'75%': {
			transform: 'scale(1.6)',
			opacity: 0.5,
		},
		'100%': {
			transform: 'scale(2)',
			opacity: 0,
		},
	},
}));

const LoadingElement = () => {
	const classes = useStyles();
	const { isEntekhabinoPage } = useFindLocation();

	return (
		<Box
			className={clsx(classes.root, {
				[classes.entekhabino]: isEntekhabinoPage,
			})}
		>
			<Box className={classes.animation}>
				<ImageKit
					src={isEntekhabinoPage ? EntekhabinoLogo : KeepaLogoWhite}
					quality={10}
					priority
					width={isEntekhabinoPage ? 280 : 160}
					height={isEntekhabinoPage ? 100 : 160}
				/>
			</Box>
		</Box>
	);
};

export default LoadingElement;
